<template>
    <v-date-picker v-model="model" :multiple="!single" no-title first-day-of-week="1" locale="es-cl"
        :show-current="false" :weekday-format="weekDays" class="container-date-picker" />
</template>

<script>
export default {
    props: {
        value: {
            type: [Array, String],
            default: null
        },
        single: {
            type: Boolean,
            default: false,
        },
        forceValue: {
            type: Boolean,
            default: false,
        }
    },
    name: "MiniCalendar",
    data(vm) {
        return {
            model: null,
            days: [
                vm.$t('days.short_sunday'),
                vm.$t('days.short_monday'),
                vm.$t('days.short_tuesday'),
                vm.$t('days.short_wednesday'),
                vm.$t('days.short_thursday'),
                vm.$t('days.short_friday'),
                vm.$t('days.short_saturday'),
            ],
        }
    },
    mounted() {
        const vm = this
        vm.setDefaults()
    },
    methods: {
        setDefaults() {
            const vm = this
            if (vm.value || vm.forceValue) vm.model = vm.value
        },
        weekDays(day) {
            const vm = this
            return vm.days[vm.$moment(day).day()]
        },
    },
    watch: {
        model(val) {
            this.$emit('change', val)
        },
        value() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>
.container-date-picker {
    padding: 12px 0;
    background-color: transparent !important;
}

::v-deep .v-picker__body {
    background: transparent;
}

/*Cuerpo del datepicker completo*/
::v-deep .v-date-picker-table {
    height: 100%;
    border-bottom: 1px solid #D9D9D9;
}

/*Text de los dias*/
::v-deep thead>tr>th {
    font-weight: 400 !important;
    font-size: 13px !important;
    line-height: 13px !important;
    color: #99CC00 !important;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active {
    color: #333333 !important;
    background-color: #CCFF99 !important;
    border-radius: 0;
    width: 100%;
}

::v-deep .v-date-picker-table .v-btn--active::before {
    opacity: 0;
}

::v-deep .v-date-picker-table .v-btn--active .v-btn__content {
    font-weight: 600;
}

::v-deep .v-date-picker-table .v-btn {
    border-radius: 0;
    width: 100%;
}
</style>